import { useState, useEffect } from "react";
import { FaArrowCircleLeft, FaTrash, FaPlusCircle, } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { FaSearch } from "react-icons/fa";
import { showSuccess, showError, showWarning } from "../../General/Toast";
import { useMemo } from "react";
import { toast } from "react-toastify";

function SaleReturn({ clientData, role }) {
  const navigate = useNavigate();
  const location = useLocation();
  const editData = location.state;

  const [ReturnDate, setReturnDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [partyName, setPartyName] = useState("");
  const [partyAddress, setPartyAddress] = useState("");
  const [partyGst, setPartyGst] = useState("");
  const [partyNo, setPartyNo] = useState("");
  const [purchaseBill, setPurchaseBill] = useState([]);
  const [returnAgainst, setReturnAgainst] = useState("");
const [received, setReceived] = useState(0);
  const [due, setDue] = useState(0);
  const [unit, setunit] = useState([]);
  const [category, setCategory] = useState([]);
  const [visitParty, setVisitParty] = useState(0);
  const [originalTotalPur, setOriginalTotalPur] = useState(0);
  const [previousBalance, setPreviousBalance] = useState(0);
  const [isIGSTBill, setIsIGSTBill] = useState(false);
  const [estimateDate, setEstimateDate] = useState(
    new Date().toISOString().slice(0, 16)
  );
  const [estimateNo, setEstimateNo] = useState("");
  const [inventory, setInventory] = useState([]);
  const [description, setDescription] = useState("");
  const [selectedBankId, setSelectedBankId] = useState(0);
  const [bankList, setBankList] = useState([]);
  const [paidAmount, setPaidAmount] = useState(0);
  const [isFullyPaid, setIsFullyPaid] = useState(false);
  const [invoiceNo, setInvoiceNo] = useState("");
  const [selectedParty, setSelectedParty] = useState(null);
  const [showPartyModal, setShowPartyModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [partyList, setPartyList] = useState([]);
  const [search, setSearch] = useState("");
 const [showExitModal, setShowExitModal] = useState(false);
  const [isNewParty, setIsNewParty] = useState(false);
  const [showPartyForm, setShowPartyForm] = useState(false);
  const [newCust, setNewCust] = useState({
    name: '',
    first_visit: '',
    last_visit: '',
    mobile: '',
    email: "",
    total_pur: "",
    total_due: "",
    loyality: '',
    visits: "",
    gstin: '',
    gst_type: "",
    gst_state: '',
    address: '',
    history: '',
    opening_balance: '',
    opening_bal_status: '',
    balance: '',
    asOfDate: '',
    p_type: '',
    client_id: '',
    invoiceNo: '',
    payment_method: ''
  })


  const [formData, setFormData] = useState({
    payment_method: '',
    client_id: '',
    description: '',
    date: '',
    mode: '',
    cb_payid: '',
    paid: '',
    client_type: '',
    category: "",
    seller_name: "",
  });
  const isEditMode = Boolean(editData);
  const currId = editData?.id || 0 ;

  useEffect(() => {
    if (!editData) return;

    setSelectedParty({
      id: editData.party_id,
      name: editData.name,
      mobile: editData.mobile,
      address: editData.address,
      gstin: editData.gstin,
    });

    setInvoiceNo(editData.invoiceNo || "");
    setPartyName(editData.name || "");
    setPartyAddress(editData.address || "");
    setPartyNo(editData.mobile || "");
    setDescription(editData.description || "");
    setEstimateDate(
      editData.date || "",
    );

    setBillDiscount({
      type:
        editData.last_discount_type === "Percentage"
          ? "percent"
          : "amount",
      value: Number(editData.last_discount || 0),
    });

    const parsed =
      typeof editData.items === "string"
        ? JSON.parse(editData.items)
        : editData.items;
const formattedRows = (parsed || []).map((item, index) => ({
  id: index + 1,

  // Inventory fields
  inventory_id: item.inventory_id || null,

  name: item.name || "",
  category: item.category || "",
  unit: item.unit || "",
qty: Number(item.quant || 0),
originalQty: Number(item.quant || 0),
  // qty: Number(item.quant || 0),
  price: Number(item.price_per_unit || 0),

  pur_price: Number(item.pur_price || 0),
  mrp: Number(item.mrp || 0),

  typeOfItem: item.typeOfItem || "product",

  discountType: item.dis_type || "percent",
  discountValue: Number(item.discount || 0),

  taxRate: item.taxRate || "",
  taxType: item.sale_price_withTax || "Without Tax",

  amount: Number(item.amount || 0),
}));

setRows(formattedRows);
    // const formattedRows = parsed.map((item, index) => ({
    //   id: index + 1,
    //   name: item.name,
    //   category: item.category,
    //   unit: item.unit,
    //   qty: Number(item.quant),
    //   price: Number(item.price_per_unit),
    //   discountType: item.dis_type || "percent",
    //   discountValue: Number(item.discount || 0),
    //   taxRate: item.taxRate || "",
    //   taxType: item.sale_price_withTax || "Without Tax",
    //   amount: Number(item.amount),
    // }));
// const formattedRows = parsedItems.map((item, index) => {

//   // Sale item me inventory_id nahi ho to
//   // current inventory se product find karo
//   const invItem = (inventory || []).find(
//     (inv) =>
//       String(inv.name || "").trim().toLowerCase() ===
//       String(item.name || "").trim().toLowerCase()
//   );

//   return {
//     id: index + 1,

//     // IMPORTANT INVENTORY FIELDS
//     inventory_id:
//       item.inventory_id ||
//       invItem?.id ||
//       null,

//     name:
//       item.name || "",

//     category:
//       item.category || invItem?.category || "",

//     unit:
//       item.unit || invItem?.unit || "",

//     qty:
//       Number(item.quant || 0),

//     price:
//       Number(item.price_per_unit || 0),

//     // IMPORTANT
//     pur_price:
//       Number(item.pur_price || invItem?.pur_price || 0),

//     mrp:
//       Number(item.mrp || invItem?.mrp || 0),

//     // IMPORTANT
//     typeOfItem:
//       item.typeOfItem ||
//       invItem?.typeOfItem ||
//       "product",

//     discountType:
//       item.dis_type || "percent",

//     discountValue:
//       Number(item.discount || 0),

//     taxRate:
//       item.taxRate || "",

//     taxType:
//       item.sale_price_withTax || "Without Tax",

//     amount:
//       Number(item.amount || 0),
//   };
// });

setRows(formattedRows);
    setRows(formattedRows);

    setFormData((prev) => ({
      ...prev,
      payment_method: editData.payment_method || "",
      seller_name: editData.seller || '',
    }));

    setSelectedBankId(Number(editData.cb_payid || 0));

    setPaidAmount(Number(editData.received || 0));


  }, [editData]);




  const [billDiscount, setBillDiscount] = useState({
    type: "percent",
    value: 0,
  });

  const [rows, setRows] = useState([
    {
      id: 1,
      name: "",
      category: "",
      unit: "",
      price: "",
      qty: "",
      taxType: "Without Tax",
      taxRate: "",
      amount: "",
      discountType: "percent",
      discountValue: 0,
    },
  ]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => {
      const updated = { ...prev, [name]: value };

      return updated;
    });
  };

  const handleInputChangeCust = (e) => {
    const { name, value } = e.target;

    setNewCust(prev => {
      const updated = { ...prev, [name]: value };

      return updated;
    });
  };


  const fetchUnit = async () => {
    try {
      const res = await axios.get(`https://api.dectwinbilling.com/fetch-unit/${clientData.id}`);
      setunit(res.data);

    } catch (error) {
      console.log(error);
    }
  };

  const fetchCategory = async () => {
    try {
      const res = await axios.get(`https://api.dectwinbilling.com/fetch-category/${clientData.id}`);
      const filterCat =
        setCategory(res.data);

    } catch (error) {
      console.log(error);
    }
  };

  const fetchInventory = async () => {
    try {
      const res = await axios.get(`https://api.dectwinbilling.com/fetch-inventory/${clientData.id}`);
      setInventory(res.data);


    } catch (error) {
      console.log(error);
    }
  };

  const fetchbankAccount = async () => {
    try {
      const res = await axios.get(
        `https://api.dectwinbilling.com/fetch-bank-accounts/${clientData.id}`
      );

      const data =
        typeof res.data === "string"
          ? JSON.parse(res.data)
          : res.data;

      setBankList(data);

    } catch (error) {
      console.log(error);
    }
  };

  const fetchparty = async () => {
    try {
      const res = await axios.get(`https://api.dectwinbilling.com/fetch-party/${clientData.id}`);
      setPartyList(res.data);

    } catch (error) {
      console.log(error);
    }
  };

  const filteredParty = (partyList || []).filter((p) => {
    const searchText = search.toLowerCase();

    return (
      (p.name || "").toLowerCase().includes(searchText) ||
      (p.mobile || "").toLowerCase().includes(searchText) ||
      (p.gstin || "").toLowerCase().includes(searchText) ||
      (p.address || "").toLowerCase().includes(searchText)
    );
  });


  useEffect(() => {

    fetchCategory();
    fetchUnit();
    fetchInventory();
    fetchbankAccount();
    fetchparty();
  }, []);




  const addRow = () => {
    setRows([
      ...rows,
      {
        id: rows.length + 1,
        name: "",
        category: "",
        unit: "",
        price: "",
        qty: "",
        taxType: "Without Tax",
        taxRate: "",
        amount: "",
        discountType: "percent",
        discountValue: 0,
      },
    ]);
  };


  const handleRowChange = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;
    setRows(updated);
  };


  const handleSelectItem = (index, item) => {
    const updatedRows = [...rows];

    updatedRows[index] = {
      ...updatedRows[index],

      name: item.name,
      category: item.category,
      unit: item.unit,
      price: Number(item.sale_price || 0),
      tax: item.taxRate,
      qty: 1,
      amount: Number(item.sale_price || 0) * 1,
    };

    setRows(updatedRows);
  };


  const calculateRowAmount = (row) => {
  const qty = Number(row.qty || 0);
  const price = Number(row.price || 0);

  let base = qty * price;

  // Discount
  if (row.discountValue) {
    if (row.discountType === "percent") {
      base -= (base * Number(row.discountValue)) / 100;
    } else {
      base -= Number(row.discountValue);
    }
  }

  // Tax Rate (works for both "18%" and 18)
  const rate =
    parseFloat(String(row.taxRate || "").replace(/[^0-9.]/g, "")) || 0;

  if (row.taxType === "Without Tax") {
    base += (base * rate) / 100;
  }

  return base;
};

  const totalQty = rows.reduce(
    (sum, row) => sum + Number(row.qty || 0),
    0
  );


  const returnAmount = rows.reduce(
    (sum, row) => sum + Number(row.amount || 0),
    0
  );

  const subTotal = useMemo(() => {
    return rows.reduce((sum, row) => {
      return sum + calculateRowAmount(row);
    }, 0);
  }, [rows]);



  // let discountedTotal = subTotal;

  const discountedTotal = useMemo(() => {
    let total = subTotal;

    if (billDiscount.value) {
      if (billDiscount.type === "percent") {
        total -= (subTotal * billDiscount.value) / 100;
      } else {
        total -= Number(billDiscount.value);
      }
    }

    return Math.max(0, total);
  }, [subTotal, billDiscount]);


  const calculateGST = (rows) => {
    let sgst = 0;
    let cgst = 0;
    let igst = 0;

    rows.forEach((row) => {
      const qty = Number(row.qty || 0);
      const price = Number(row.price || 0);

      let base = qty * price;

      if (row.discountValue) {
        if (row.discountType === "percent") {
          base -= (base * row.discountValue) / 100;
        } else {
          base -= Number(row.discountValue);
        }
      }

      const rate =
        parseFloat((row.taxRate || "").replace(/[^0-9.]/g, "")) || 0;

      const taxAmount = (base * rate) / 100;

      if (!row.taxRate) return;

      if (row.taxRate.startsWith("GST")) {
        sgst += taxAmount / 2;
        cgst += taxAmount / 2;
      } else if (row.taxRate.startsWith("IGST")) {
        igst += taxAmount;
      }
    });

    return {
      sgst,
      cgst,
      igst,
      totalTax: sgst + cgst + igst,
    };
  };

  // const buildItemsPayload = () => {
  //   return rows.map((row, index) => {
  //     const qty = Number(row.qty || 0);
  //     const price = Number(row.price || 0);

  //     const base = qty * price;

  //     // discount
  //     let discountAmount = 0;
  //     if (row.discountType === "percent") {
  //       discountAmount = (base * Number(row.discountValue || 0)) / 100;
  //     } else {
  //       discountAmount = Number(row.discountValue || 0);
  //     }

  //     const afterDiscount = base - discountAmount;

  //     // tax
  //     const taxRate = parseFloat(
  //       (row.taxRate || "").replace(/[^0-9.]/g, "")
  //     ) || 0;

  //     const taxAmount =
  //       row.taxType === "Without Tax"
  //         ? (afterDiscount * taxRate) / 100
  //         : 0;

  //     const finalAmount = afterDiscount + taxAmount;

  //     // const totalMRP = qty * mrp;

  //     return {
  //       id: row.id || null,
  //       SNo: index + 1,
  //       name: row.name,
  //       quant: qty,
  //       unit: row.unit,
  //       price_per_unit: price,
  //       discount: row.discountValue || 0,
  //       dis_type: row.discountType,
  //       taxRate: row.taxRate || "None",
  //       taxAmount: Number(taxAmount.toFixed(2)),
  //       amount: Number(finalAmount.toFixed(2)),

  //       category: row.category || "",
  //       pur_price: row.pur_price || 0,
  //       mrp: row.mrp || 0,
  //       typeOfItem: row.typeOfItem,
  //       sale_price_withTax: row.taxType || "Without Tax",

  //       stockReducer: ["", row.name, qty],
  //     };
  //   });
  // };
const buildItemsPayload = () => {
  return rows
    .filter(
      (row) =>
        row.name &&
        Number(row.qty || 0) > 0
    )
    .map((row, index) => {

      const qty =
        Number(row.qty || 0);

      const price =
        Number(row.price || 0);

      const base =
        qty * price;

      let discountAmount = 0;

      if (
        row.discountType === "percent"
      ) {
        discountAmount =
          (base *
            Number(
              row.discountValue || 0
            )) /
          100;
      } else {
        discountAmount =
          Number(
            row.discountValue || 0
          );
      }

      const afterDiscount =
        base - discountAmount;

      const taxRate =
        parseFloat(
          String(row.taxRate || "")
            .replace(/[^0-9.]/g, "")
        ) || 0;

      const taxAmount =
        row.taxType === "Without Tax"
          ? (afterDiscount * taxRate) / 100
          : 0;

      const finalAmount =
        afterDiscount + taxAmount;

      return {
        id:
          row.id || null,

        SNo:
          index + 1,

        // IMPORTANT
        inventory_id:
          row.inventory_id || null,

        name:
          row.name || "",

        quant:
          qty,

        unit:
          row.unit || "",

        price_per_unit:
          price,

        // IMPORTANT
        pur_price:
          Number(row.pur_price || 0),

        mrp:
          Number(row.mrp || 0),

        typeOfItem:
          row.typeOfItem || "product",

        discount:
          Number(row.discountValue || 0),

        dis_type:
          row.discountType || "percent",

        taxRate:
          row.taxRate || "None",

        taxAmount:
          Number(
            taxAmount.toFixed(2)
          ),

        amount:
          Number(
            finalAmount.toFixed(2)
          ),

        category:
          row.category || "",

        sale_price_withTax:
          row.taxType ||
          "Without Tax",

        stockReducer:
          ["", row.name, qty],
      };
    });
};
  const handleSubmit = async () => {

    try {
      const itemsPayload = buildItemsPayload();
      const { sgst, cgst, igst, totalTax } = calculateGST(rows);

      const paymentMethod = (formData.payment_method || "")
        .trim()
        .toLowerCase();

      const bankId =
        paymentMethod === "cash" ? 0 : Number(selectedBankId ?? 0);

      const totalDis = rows.reduce((total, row) => {
        const qty = Number(row.qty || 0);
        const price = Number(row.price || 0);

        const base = qty * price;

        let discountAmount = 0;

        if (row.discountType === "percent") {
          discountAmount = (base * Number(row.discountValue || 0)) / 100;
        } else {
          discountAmount = Number(row.discountValue || 0);
        }

        return total + discountAmount;
      }, 0);


      const totalSP = rows.reduce((total, row) => {
        const qty = Number(row.qty || 0);
        const price = Number(row.price || 0);

        return total + (qty * price);
      }, 0);



      const totalMRP = rows.reduce((total, row) => {
        const qty = Number(row.qty || 0);

        return total + (qty * Number(row.mrp || 0));
      }, 0);

      const payload = {
       inv_against: returnAgainst,
        cId: selectedParty?.id,
        cust_name: selectedParty?.name,
        cust_address: selectedParty?.address,
        cust_number: selectedParty?.mobile,
        gstin: selectedParty?.gstin,
        loyality_redeem: selectedParty?.loyality_redeem || 0,
        loyalty_percent: selectedParty?.loyality || 0,
        payable: payableAmount,
        // recieved: paidAmount,
        // due: dueAmount,
        date: estimateDate,
        seller: formData.seller_name,
        items: itemsPayload,

        // payment_method: formData.payment_method || null,
        mode: formData.payment_method,
        acc_id: bankId,


        last_discount: Number(billDiscount.value || 0),

        last_discount_type:
          billDiscount.type === "percent"
            ? "Percentage"
            : "Amount",

        onChangeForDiscount:
          billDiscount.type === "percent"
            ? Number(billDiscount.value || 0)
            : 0,

        totalSP: Number(totalSP.toFixed(2)),

        totalDis: Number(totalDis.toFixed(2)),
        total_mrp: Number(totalMRP.toFixed(2)),
        totalMRP: Number(totalMRP.toFixed(2)),
        total_pp: 0,
        totalPP: 0,
        total_saveOnMrp: 0,
        sgst: Number(sgst.toFixed(2)),
        cgst: Number(cgst.toFixed(2)),
        igst: Number(igst.toFixed(2)),
        totalTax: Number(totalTax.toFixed(2)),

        description,
        client_type: role,
      };

      let res;

      if (isEditMode) {

        payload.last_edited_by = clientData.id;
        payload.last_edited = new Date();
        payload.last_edited_type = clientData.role;
         payload.client_id = editData.client_id;

        res = await axios.put(
          `https://api.dectwinbilling.com/api/update-new-sale/${currId}`,
          payload
        );

        showSuccess("Sale Bill updated successfully");
        // navigate("/sale-history");
            navigate("/invoice-preview", {
    state: {


      invoice: {
  ...payload,
  invoiceNo: res.data?.data?.invoiceNo
},
          billTitle: "SALE INVOICE"
    }
  });
      } else {
        // Create new estimate

        res = await axios.post(
          `https://api.dectwinbilling.com/api/new-sales-return-bill/${clientData.id}`,
          payload
        );

        showSuccess("Sale Return Invoice creating successfully");

        navigate("/invoice-preview", {
    state: {

      invoice: {
  ...payload,
  invoiceNo: res.data?.data?.invoiceNo
},
       billTitle: "SALE RETURN INVOICE"
    }
  });
      }
      resetForm();
    } catch (err) {
      console.error(err);
      showError(
        isEditMode
          ? "Failed to update sale bill"
          : "Failed to save sale bill"
      );
    }
  };

  const { sgst, cgst, igst, totalTax } = useMemo(() => {
    return calculateGST(rows);
  }, [rows]);


  const resetForm = () => {
    setReturnDate(new Date().toISOString().split("T")[0]);

    // Party Details
    setSelectedParty(null);
    setPartyName("");
    setPartyAddress("");
    setPartyGst("");
    setPartyNo("");

    // Seller
    setFormData((prev) => ({
      ...prev,
      seller_name: "",
      payment_method: "",
      cb_payid: 0,
    }));

    // Bank
    setSelectedBankId(0);

    // Description
    setDescription("");

    // Bill Discount
    setBillDiscount({
      type: "percent",
      value: 0,
    });

    // Payment
    setIsFullyPaid(false);
    setPaidAmount(0);
    setReceived(0);
    setDue(0);

    // Party Visit Details
    setVisitParty(0);
    setOriginalTotalPur(0);
    setPreviousBalance(0);

    // Return
    setReturnAgainst("");

    // Items
    setRows([
      {
        id: 1,
        name: "",
        category: "",
        unit: "",
        price: "",
        qty: "",
        tax: "",
        amount: "",
        taxMode: "GST",
        taxRate: 0,
        taxType: "Without Tax",
        discountType: "percent",
        discountValue: 0,
      },
    ]);
  };

  const paymentMethod = formData.payment_method || editData?.mode;

  const taxableTotal = useMemo(() => {
    return rows.reduce((sum, row) => sum + calculateRowAmount(row), 0);
  }, [rows]);

  const discountAmount = useMemo(() => {
    if (!billDiscount.value) return 0;

    if (billDiscount.type === "percent") {
      return (taxableTotal * billDiscount.value) / 100;
    }

    return billDiscount.value;
  }, [taxableTotal, billDiscount]);

  const payableAmount = Math.max(taxableTotal - discountAmount, 0);


  const paid = isFullyPaid ? payableAmount : Number(paidAmount || 0);

  const getBillState = () => ({
    invoiceNo,
    estimateDate,
    formData,
    selectedParty,
    rows,
    billDiscount,
    description,
    paidAmount,
    isFullyPaid,
    selectedBankId,
    payableAmount,
  });

  const clearBill = () => {
    resetForm();
    setShowExitModal(false);
    navigate("/home");
  };

  const MAX_HELD_BILLS = 5;
  const holdBill = () => {
    const heldBills =
      JSON.parse(localStorage.getItem("heldBills")) || {};

    if (Object.keys(heldBills).length >= MAX_HELD_BILLS) {
      toast.error("Maximum limit of 5 held bills reached. Please resume or clear a held bill before holding another.");
      return;
    }

    const key = `Bill ${Object.keys(heldBills).length + 1}`;

    heldBills[key] = getBillState();

    localStorage.setItem(
      "heldBills",
      JSON.stringify(heldBills)
    );

    setShowExitModal(false);
    navigate("/home");
  };

  const heldBills =
    JSON.parse(localStorage.getItem("heldBills")) || {};

  const loadBill = (key) => {
    const heldBills = JSON.parse(localStorage.getItem("heldBills")) || {};

    const bill = heldBills[key];

    if (!bill) return;

    setInvoiceNo(bill.invoiceNo);
    setEstimateDate(bill.estimateDate);
    setFormData(bill.formData);
    setSelectedParty(bill.selectedParty);
    setRows(bill.rows);
    setBillDiscount(bill.billDiscount);
    setDescription(bill.description);
    setPaidAmount(bill.paidAmount);
    setIsFullyPaid(bill.isFullyPaid);
    setSelectedBankId(bill.selectedBankId);

    // Remove the bill after loading (optional)
    delete heldBills[key];

    localStorage.setItem(
      "heldBills",
      JSON.stringify(heldBills)
    );
  };


  const handleSubmitParty = async (e) => {
    e.preventDefault();

    if (!newCust.name) {
      showWarning("Name  are required!", "danger");
      return;
    }

    try {
      const today = new Date().toISOString().split("T")[0];


      const sendData = {
        name: newCust.name,
        mobile: newCust.mobile,
        gstin: newCust.gstin,
        email: newCust.email,

        gst_type: newCust.gst_type,
        gst_state: newCust.gst_state,
        address: newCust.address,
        opening_balance: newCust.opening_balance,
        asOfDate: newCust.asOfDate,
        p_type: "Customer",
        client_id: clientData.id,
        first_visit: today,
        last_visit: today,
        total_pur: 0,
        total_due: 0,
        loyality: 0,
        visits: 0,
        opening_bal_status: '',
        balance: 0,
      };

      let res;



      res = await axios.post(
        "https://api.dectwinbilling.com/add-party",
        sendData
      );

      const newPartyId = res.data.insertedId;

      const partyRes = await axios.get(
        `https://api.dectwinbilling.com/get-party/${newPartyId}`
      );

      const createdParty = partyRes.data.party;

      showSuccess("Party Added Successfully!", "success");
      resetFormParty();

      setSelectedParty(createdParty);
      setIsNewParty(false);
      setShowPartyForm(false);
      setPartyName(createdParty.name);
      setPartyNo(createdParty.mobile || "");
      setPartyAddress(createdParty.address || "");
      setPartyGst(createdParty.gstin || "");

      fetchparty();

    } catch (err) {
      console.error("❌ Error:", err.response?.data || err.message);

      showError(
        err.response?.data?.message || "Failed to save party!",
        "danger"
      );
    }
  };

  const resetFormParty = () => {
    setNewCust({
      name: '',
      first_visit: '',
      last_visit: '',
      mobile: '',
      email: "",
      total_pur: "",
      total_due: "",
      loyality: '',
      visits: "",
      gstin: '',
      gst_type: '',
      gst_state: '',
      address: '',
      history: '',
      opening_balance: '',
      opening_bal_status: '',
      balance: '',
      asOfDate: '',
      p_type: '',
      client_id: ''
    })

  }

const handleSearchPurchase = async () => {
  if (!returnAgainst) {
    showWarning("Please enter invoice number");
    return;
  }

  try {
    const response = await axios.get(
      `https://api.dectwinbilling.com/api/fetch-sale-detail/${returnAgainst}`
    );

    const data = response.data[0];

    if (!data) {
      showError("Sale not found");
      return;
    }

    // ==============================
    // PARTY DETAILS
    // ==============================

    setSelectedParty({
      id: data.party_id,
      name: data.name,
      mobile: data.mobile,
      address: data.address,
      gstin: data.gstin,
    });

    setInvoiceNo(data.invoiceNo || "");
    setPartyName(data.name || "");
    setPartyAddress(data.address || "");
    setPartyNo(data.mobile || "");
    setDescription(data.description || "");
    setEstimateDate(data.date || "");

    // ==============================
    // BILL DISCOUNT
    // ==============================

    setBillDiscount({
      type:
        data.last_discount_type === "Percentage"
          ? "percent"
          : "amount",

      value:
        Number(data.last_discount || 0),
    });

    // ==============================
    // PAYMENT
    // ==============================

    setFormData((prev) => ({
      ...prev,
      payment_method: data.payment_method || "",
      seller_name: data.seller || "",
    }));

    setSelectedBankId(
      Number(data.cb_payid || 0)
    );

    // ==============================
    // ITEMS
    // ==============================

    const parsedItems =
      typeof data.items === "string"
        ? JSON.parse(data.items)
        : data.items;

    if (!Array.isArray(parsedItems)) {
      showError("Invalid sale items");
      return;
    }

    // ==============================
    // IMPORTANT:
    // inventory variable use nahi karna
    // ==============================

    const formattedRows = parsedItems.map(
      (item, index) => ({
        id: index + 1,

        // INVENTORY ID
        inventory_id:
          item.inventory_id || null,

        name:
          item.name || "",

        category:
          item.category || "",

        unit:
          item.unit || "",

        qty:
          Number(item.quant || 0),

        price:
          Number(item.price_per_unit || 0),

        // INVENTORY VALUES
        pur_price:
          Number(item.pur_price || 0),

        mrp:
          Number(item.mrp || 0),

        typeOfItem:
          item.typeOfItem || "product",

        discountType:
          item.dis_type || "percent",

        discountValue:
          Number(item.discount || 0),

        taxRate:
          item.taxRate || "",

        taxType:
          item.sale_price_withTax ||
          "Without Tax",

        amount:
          Number(item.amount || 0),
      })
    );

    setRows(formattedRows);

  } catch (error) {
    console.error(
      "Sale Return Search Error:",
      error.response?.data || error
    );

    showError(
      error.response?.data?.message ||
      "Sale not found"
    );
  }
};

// const handleSearchPurchase = async () => {
//   if (!returnAgainst) {
//     showWarning("Please enter invoice number");
//     return;
//   }

//   try {
//     const response = await axios.get(
//       `https://api.dectwinbilling.com/api/fetch-sale-detail/${returnAgainst}`
//     );

//     const data = response.data[0];



//     // Party Details
//     setSelectedParty({
//       id: data.party_id,
//       name: data.name,
//       mobile: data.mobile,
//       address: data.address,
//       gstin: data.gstin,
//     });

//     setInvoiceNo(data.invoiceNo || "");
//     setPartyName(data.name || "");
//     setPartyAddress(data.address || "");
//     setPartyNo(data.mobile || "");
//     setDescription(data.description || "");
//     setEstimateDate(data.date || "");

//     // Bill Discount
//     setBillDiscount({
//       type:
//         data.last_discount_type === "Percentage"
//           ? "percent"
//           : "amount",
//       value: Number(data.last_discount || 0),
//     });

//     // Payment Details
//     setFormData((prev) => ({
//       ...prev,
//       payment_method: data.payment_method || "",
//       seller_name: data.seller || "",
//     }));

//     setSelectedBankId(Number(data.cb_payid || 0));

//     // setPaidAmount(Number(data.received || 0));

//     // Items
//     const parsedItems =
//       typeof data.items === "string"
//         ? JSON.parse(data.items)
//         : data.items;

//     const formattedRows = parsedItems.map((item, index) => ({
//       id: index + 1,
//       name: item.name,
//       category: item.category,
//       unit: item.unit,
//       qty: Number(item.quant),
//       price: Number(item.price_per_unit),
//       discountType: item.dis_type || "percent",
//       discountValue: Number(item.discount || 0),
//       taxRate: item.taxRate || "",
//       taxType: item.sale_price_withTax || "Without Tax",
//       amount: Number(item.amount),
//     }));

//   setRows(formattedRows);

//   } catch (error) {
//     console.error(error);
//     showError("Sale not found");
//   }
// };
  return (

   <div>
        <div className="page-wrapper">
  
          <div className="page-content">
  
  
            <div className="page-header d-flex align-items-center justify-content-start mb-3">
              <div className="d-flex align-items-center gap-2">
                <FaArrowCircleLeft
                  style={{ cursor: "pointer", fontSize: "24px" }}
                  onClick={() => navigate("/home")}
     
                />
  
                <h4 className="mb-0">Sale Return</h4>
              </div>
  
              <div className="d-flex gap-2 flex-wrap">
  
  
                {Object.keys(heldBills).map((key) => (
                  <button
                    key={key}
                    className="btn btn-success me-2"
                    onClick={() => loadBill(key)}
                  >
                    {key}
                  </button>
                ))}
              </div>
            </div>
  
            <div className="container-fluid mt-3">
              <div className="row g-3">
  
  
                <div className="col-md-4">
  
                  <div
                    className=" p-4 rounded shadow-sm"
                    style={{ width: "300px", backgroundColor: 'var(--card-color)' }}
                  >
                 
                    {/* <div className="mb-3 position-relative">
                      <input
                        type="text"
                        readOnly
                        className="form-control"
                        style={{ paddingLeft: "115px" }}
                        value={invoiceNo}
                      />
                      <span
                        className="position-absolute top-50 start-0 translate-middle-y ms-1 fw-medium"
                      >
                        Invocie No:
                      </span>
                    </div>
   */}


     <div className="mb-3 position-relative">
                     <strong>Return Against</strong>

  <div className="input-group mt-2">
    <input
      className="form-control"
      placeholder="Enter Invoice Number"
      value={returnAgainst}
      onChange={(e) => setReturnAgainst(e.target.value)}
    />

    <button
      className="btn btn-primary"
      onClick={handleSearchPurchase}
    >
      <FaSearch />
    </button>
  </div>
  
  
                    </div>
                    {/* Estimate Date */}
                    <div className="mb-3 position-relative ">
                      <input
                        type="datetime-local"
                        className="form-control"
                        style={{ paddingLeft: "100px" }}
                        value={estimateDate}
                        onChange={(e) => setEstimateDate(e.target.value)}
                      />
                      <span
                        className="position-absolute top-50 start-0 translate-middle-y ms-1 fw-medium"
                        style={{ pointerEvents: "none" }}
                      >
                        Invoice Date:
                      </span>
                    </div>
  
                  </div>
                </div>
  
  
  
                <div className="col-md-4 ms-auto">
            
  
                  <div className="d-flex align-items-center mb-2">
                    <span className="me-2 flex-shrink-0 fw-medium" style={{ width: "130px" }}>
                      Customer Name:
                    </span>
  
                    <input
                      type="text"
                      placeholder="Enter Party Name"
                      style={{
                        width: "100%",
                        marginTop: "10px",
                        padding: "10px",
                        border: "1px solid #ccc",
                        borderRadius: "6px",
                        outline: "none",
                        boxSizing: "border-box",
                      }}
  
                      value={isNewParty ? partyName : selectedParty?.name || ""}
                      readOnly={!isNewParty}
                      onClick={() => {
                        if (!isNewParty) {
                          setShowPartyModal(true);
                        }
                      }}
                      onChange={(e) => setPartyName(e.target.value)}
                    />
                  </div>
  
                  <div className="d-flex align-items-center mb-2">
                    <span className="me-2 flex-shrink-0 fw-medium" style={{ width: "130px" }}>
                      Mobile Number:
                    </span>
                    <input
                      className="form-control"
                      //  value={selectedParty?.mobile || ""}
                      // onChange={(e) => setPartyNo(e.target.value)}
                      value={isNewParty ? partyNo : selectedParty?.mobile || ""}
                      readOnly={!isNewParty}
                      onChange={(e) => setPartyNo(e.target.value)}
                      required
                    />
                  </div>
  
                  <div className="d-flex align-items-center mb-2">
                    <span className="me-2 flex-shrink-0 fw-medium" style={{ width: "130px" }}>
                      Address:
                    </span>
                    <input
                      className="form-control"
                      // value={selectedParty?.address || ""}
                      //   onChange={(e) => setPartyAddress(e.target.value)}
                      //   required
  
                      value={isNewParty ? partyAddress : selectedParty?.address || ""}
                      readOnly={!isNewParty}
                      onChange={(e) => setPartyAddress(e.target.value)}
                    />
                  </div>
  
                  <div className="d-flex align-items-center">
                    <span className="me-2 flex-shrink-0 fw-medium" style={{ width: "130px" }}>
                      GSTIN Number:
                    </span>
                    <input
                      className="form-control"
                      // value={selectedParty?.gstin || ""}
                      //   onChange={(e) => setPartyGst(e.target.value)}
                      value={isNewParty ? partyGst : selectedParty?.gstin || ""}
                      readOnly={!isNewParty}
                      onChange={(e) => setPartyGst(e.target.value)}
                    />
                  </div>
  
  
                </div>
  
              </div>
            </div>
  
            <div className="container-fluid mt-3">
              <div className="table-wrapper p-2">
  
                <table className="table table-bordered custom-table mb-0"
                  style={{ tableLayout: "fixed" }}
                >
  
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: "70px" }}>SN</th>
                      <th style={{ width: "250px" }}>Item</th>
                      <th style={{ width: "90px" }}>Qty</th>
                      <th style={{ width: "140px" }}>Unit</th>
                      <th style={{ width: "140px" }}>Price/Unit</th>
                      <th style={{ width: "240px" }}>Discount</th>
                      <th style={{ width: "260px" }}>Tax</th>
                      <th style={{ width: "140px" }}>Amount</th>
                    </tr>
                  </thead>
  
                  <tbody>
                    {rows.map((row, index) => (
                      <tr key={row.id}>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <span>{index + 1}</span>
  
                            <FaTrash
                              color="red"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                setRows(rows.filter((_, i) => i !== index))
                              }
                            />
                          </div>
                        </td>
  
                        <td>
                          <select
                            className="form-select form-select-sm"
                            style={{ width: "100%" }}
                            value={row.name}
                            onChange={(e) => {
                              const item = inventory.find(
                                (inv) => inv.name === e.target.value
                              );
  
                              if (item) {
                                handleSelectItem(index, item);
                              }
                            }}
                          >
                            <option value="">Select Item</option>
  
                            {inventory.map((item) => (
                              <option key={item.id} value={item.name}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                        </td>
  
  
  
                        <td>
                          <input
  type="number"
  min="0"
  max={Number(row.originalQty || 0)}
  className="form-control form-control-sm text-center"
  value={row.qty ?? ""}
  onChange={(e) => {
    const updatedRows = [...rows];

    const maxQty = Number(
      updatedRows[index].originalQty || 0
    );

    let qty = Number(e.target.value);

    if (!Number.isFinite(qty) || qty < 0) {
      qty = 0;
    }

    if (qty > maxQty) {
      qty = maxQty;

      showWarning(
        `Maximum return quantity is ${maxQty}`
      );
    }

    updatedRows[index] = {
      ...updatedRows[index],
      qty: qty,
    };

    setRows(updatedRows);
  }}
/>
                          {/* <input
                            type="number"
                            className="form-control form-control-sm text-center"
                            value={row.qty || ""}
                            onChange={(e) => {
                              const updatedRows = [...rows];
  
                              const qty = Number(e.target.value) || 0;
                              const price = Number(updatedRows[index].price) || 0;
  
                              updatedRows[index].qty = qty;
                              setRows(updatedRows);
                            }}
                          /> */}
                        </td>
  
  
  
                        <td>
                          <select
                            className="form-select form-select-sm"
                            style={{ width: "100%" }}
                            value={row.unit || ""}
                            onChange={(e) => {
                              const updatedRows = [...rows];
                              updatedRows[index].unit = e.target.value;
                              setRows(updatedRows);
                            }}
                          >
                            <option value="">Select Unit</option>
  
                            {unit.map((u) => (
                              <option
                                key={u.id}
                                value={u.cat_name}
                              >
                                {u.cat_name}
                              </option>
                            ))}
                          </select>
                        </td>
  
  
                        <td>
                          <input
                            type="number"
                            className="form-control form-control-sm text-end"
                            value={row.price || ""}
                            onChange={(e) => {
                              const updatedRows = [...rows];
  
                              const price = Number(e.target.value) || 0;
                              const qty = Number(updatedRows[index].qty) || 0;
  
                              updatedRows[index].price = price;
                              // updatedRows[index].amount = qty * price;
                              // updatedRows[index].amount = calculateRowAmount(updatedRows[index]);
                              setRows(updatedRows);
                            }}
                          />
                        </td>
  
  
                        <td>
                          <div className="d-flex gap-2 align-items-center">
  
                            <select
                              className="form-select form-select-sm"
                              style={{ minWidth: "110px" }}
                              value={row.discountType}
                              onChange={(e) => {
                                const updated = [...rows];
                                updated[index].discountType = e.target.value;
  
                                // updated[index].amount = calculateRowAmount(updated[index]);
  
                                setRows(updated);
                              }}
                            >
                              <option value="percent">Percent (%)</option>
                              <option value="amount">Amount (₹)</option>
                            </select>
  
                            <input
                              type="number"
                              className="form-control form-control-sm text-end"
                              value={row.discountValue || ""}
                              onChange={(e) => {
                                const updated = [...rows];
  
                                updated[index].discountValue = Number(e.target.value);
  
                                // updated[index].amount = calculateRowAmount(updated[index]);
  
                                setRows(updated);
                              }}
                            />
  
                          </div>
                        </td>
  
                        <td>
                          <div className="d-flex gap-2">
  
                            <select
                              className="form-select form-select-sm"
                              style={{ width: "130px" }}
                              value={row.taxType}
                              onChange={(e) => {
                                const updated = [...rows];
                                updated[index].taxType = e.target.value;
  
                                // updated[index].amount = calculateRowAmount(updated[index]);
  
                                setRows(updated);
                              }}
                            >
                              <option value="With Tax">With Tax</option>
                              <option value="Without Tax">Without Tax</option>
                            </select>
                            <select
                              className="form-select form-select-sm"
                              style={{ width: "130px" }}
                              value={row.taxRate}
                              onChange={(e) => {
                                const updated = [...rows];
  
                                const value = e.target.value;
                                updated[index].taxRate = value;
  
                                // updated[index].amount = calculateRowAmount(updated[index]);
  
                                setRows(updated);
                              }}
                            >
                              <option value="">Tax Rate</option>
  
                              <option value="GST 0%">GST 0%</option>
                              <option value="IGST 0%">IGST 0%</option>
  
                              <option value="GST 0.25%">GST 0.25%</option>
                              <option value="IGST 0.25%">IGST 0.25%</option>
  
                              <option value="GST 3%">GST 3%</option>
                              <option value="IGST 3%">IGST 3%</option>
  
                              <option value="GST 5%">GST 5%</option>
                              <option value="IGST 5%">IGST 5%</option>
  
                              <option value="GST 12%">GST 12%</option>
                              <option value="IGST 12%">IGST 12%</option>
  
                              <option value="GST 18%">GST 18%</option>
                              <option value="IGST 18%">IGST 18%</option>
  
                              <option value=">GST 28%">GST 28%</option>
                              <option value="IGST 28%">IGST 28%</option>
                            </select>
  
                          </div>
                        </td>
  
  
                        <td className="fw-bold text-end text-success">
                          ₹ {calculateRowAmount(row).toFixed(2)}
                        </td>
  
                      </tr>
                    ))}
                  </tbody>
  
                </table>
  
              
  
              </div>
            </div>
  
            <div className="container-fluid mt-3">
              <div className="summary-box">
                <div className="summary-left">
                  <strong>Total</strong>
                </div>
  
                <div className="summary-right">
                  <div>{totalQty} </div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div> ₹ {totalTax.toFixed(2)}</div>
                  <div>₹ {subTotal}</div>
                </div>
              </div>
            </div>
  
     <div className="container-fluid mt-3 mb-3">
  <div className="row justify-content-end">
    <div className="col-md-4">
      <div
        style={{
          background: "#ece7e7",
          padding: "15px",
          borderRadius: "15px",
          width: "100%",
          maxWidth: "350px",
          marginLeft: "auto",
        }}
      >
        <div className="invoice-box">
          <strong>Total Amount :</strong> ₹ {payableAmount.toFixed(2)}
        </div>
      </div>
    </div>
  </div>
</div>
  
          </div>
  
          <div className="footer-bar mt-4">
            <button className="btn-clear btn btn-secondary" onClick={() => resetForm()} >Clear Bill</button>
            <button className="btn-save btn btn-success" onClick={handleSubmit} >  {isEditMode ? "Update & Print" : "Save & Print"}</button>
            <button className="btn-preview btn btn-primary" onClick={handleSubmit} >  {isEditMode ? "Update & Share" : "Preview & Share"}</button>
          </div>
  
        </div>
  
        {showPartyModal && (
          <div
            className="modal show fade d-block"
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0,0,0,0.6)" }}
          >
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content shadow-lg border-0 rounded-3">
  
  
                <div className="modal-header  text-white" style={{ backgroundColor: 'var(--primary-color)' }}>
                  <h5 className="modal-title text-white">Select Party</h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setShowPartyModal(false)}
                  />
                </div>
  
  
                <div className="modal-body">
  
                  <input
                    type="text"
                    className="form-control mb-3"
                    placeholder="Search by name, mobile, GST..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
  
  
                  <div
                    className="list-group"
                    style={{ maxHeight: "350px", overflowY: "auto" }}
                  >
                    {filteredParty.length > 0 ? (
                      filteredParty.map((p) => (
                        <button
                          key={p.id}
                          type="button"
                          className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                          onClick={() => {
                            setSelectedParty(p);
                            setShowPartyModal(false);
                          }}
                        >
                          <div>
                            <div className="fw-bold">{p.name}</div>
                            <small className="text-muted">
                              {p.mobile} | GST: {p.gstin || "NA"}
                            </small>
                          </div>
  
                          <span className="badge bg-success">
                            Select
                          </span>
                        </button>
                      ))
                    ) : (
                      <div className="text-center text-muted py-3">
                        No party found
                      </div>
                    )}
                  </div>
                </div>
  
  
                <div className="modal-footer justify-content-end">
  
  
                  <button
                    className="btn-credit"
                    onClick={() => setShowPartyModal(false)}
                  >
                    Close
                  </button>
                </div>
  
              </div>
            </div>
          </div>
        )}
  
        {showExitModal && (
          <div
            className="modal show d-block"
            style={{ background: "rgba(0,0,0,.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
  
                <div className="modal-header">
                  <h5>Leave Bill?</h5>
                </div>
  
                <div className="modal-body">
                  <p>What would you like to do with this bill?</p>
                </div>
  
                <div className="modal-footer">
                  <button
                    className="btn btn-danger"
                    onClick={clearBill}
                  >
                    Clear Bill
                  </button>
  
                  <button
                    className="btn btn-warning"
                    onClick={holdBill}
                  >
                    Hold Bill
                  </button>
  
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowExitModal(false)}
                  >
                    Cancel
                  </button>
  
                </div>
  
              </div>
            </div>
          </div>
        )}
  
  
        {showPartyForm && (
          <div className="party-modal-overlay">
            <form onSubmit={handleSubmitParty}>
              <div className="party-details-modal">
  
                <h2 className="modal-title">Customer Details</h2>
  
                <div className="party-details-grid">
  
                  {/* LEFT SECTION */}
                  <div className="details-column">
  
                    <div className="detail-row">
                      <label>Name :</label>
                      <input
                        type="text"
                        name="name"
                        value={newCust.name}
                        onChange={handleInputChangeCust}
                        required
                      />
                    </div>
  
                    <div className="detail-row">
                      <label>Contact :</label>
                      <input
                        type="text"
                        name="mobile"
                        value={newCust.mobile}
                        onChange={handleInputChangeCust}
  
                        maxLength={10}
                      />
                    </div>
  
                    <div className="detail-row">
                      <label> GSTIN :</label>
                      <input
                        type="text"
                        name="gstin"
                        value={newCust.gstin}
                        onChange={handleInputChangeCust}
                      />
                    </div>
  
                    <div className="detail-row">
                      <label>Email :</label>
                      <input
                        type="email"
                        name="email"
                        value={newCust.email}
                        onChange={handleInputChangeCust}
                      />
                    </div>
  
                    <div className="detail-row">
                      <label>Total Purchase :</label>
                      <span>{newCust.total_pur || 0}</span>
                    </div>
  
                    <div className="detail-row">
                      <label>Opening Bal :</label>
                      <input type="number"
                        name="opening_balance"
                        value={newCust.opening_balance}
                        onChange={handleInputChangeCust}
  
                        disabled={isEditMode}
                      />
                    </div>
  
                  </div>
  
                  {/* RIGHT SECTION */}
                  <div className="details-column">
  
                    <div className="detail-row">
                      <label>GSTIN Type :</label>
  
                      <select
                        name="gst_type"
                        value={newCust.gst_type}
                        onChange={handleInputChangeCust}
                      >
                        <option value="">Select</option>
                        <option value="Registered">Registered</option>
                        <option value="Unregistered">Unregistered</option>
                      </select>
                    </div>
  
                    <div className="detail-row">
                      <label>GSTIN State :</label>
                      <input
                        type="text"
                        name="gst_state"
                        value={newCust.gst_state}
                        onChange={handleInputChangeCust}
                      />
                    </div>
  
                    <div className="detail-row address-row">
                      <label>GSTIN Address :</label>
  
                      <textarea
                        name="address"
                        value={newCust.address}
                        onChange={handleInputChangeCust}
                      />
                    </div>
  
                    {isEditMode && (
                      <div className="detail-row total-due-row">
                        <label>Total Due :</label>
                        <input type="number"
                          name="total_due"
                          value={newCust.total_due || 0}
                          onChange={handleInputChangeCust}
  
                          disabled={isEditMode}
                        />
                      </div>
                    )}
  
  
                    {!isEditMode && (
                      <div className="detail-row">
                        <label>As Of Date :</label>
                        <input type="datetime-local"
                          name="asOfDate"
                          value={newCust.asOfDate}
                          onChange={handleInputChangeCust}
  
  
                        />
                      </div>
                    )}
  
                  </div>
  
                </div>
  
                <div className="modal-footer">
                  <button
                    type="button"
                    className="close-btn"
                    onClick={() => {
                      setShowPartyForm(false);
                      resetForm();
                    }}
                  >
                    Close
                  </button>
  
                  <button className="submit-btn" type="submit">
                    {isEditMode ? "Update Details" : "Submit Details"}
                  </button>
                </div>
  
              </div>
            </form>
          </div>
        )}
      </div>
  )
}

export default SaleReturn
